<div #splitButton class="agpr-splitButton" (clickOutside)="hide()">
    <div #button class="agpr-splitButton-btn" >
        <agpr-button
            [ngClass]="{'agpr-splitButton-btn--active': panelVisible}"
            [id]="id"
            [style]="style"
            [label]="label"
            [icon]="icon"
            [tooltip]="tooltip"
            [tooltipPosition]="tooltipPosition"
            [disabled]="disabled"
            [loading]="loading"
            (click)="onMouseClick()"
            ariaHaspopup="menu"
            [expanded]="panelVisible ? true : false"
            [ariaControls]="id + '_buttonList'"
        >
            <span
                *ngIf="showTriggerIcon"
                class="agpr-splitButton-triggerIcon"
                [ngClass]="[caretDown ? 'fa-solid fa-angle-down' : 'fa-solid fa-angle-up', primaryTriggerIcon ? 'agpr-splitButton-triggerIcon--primary' : '']"
            ></span>
        </agpr-button>
    </div>
    <div
        #panel
        class="agpr-clickOutsideExcluded agpr-splitButton-panel"
        [ngClass]="{'agpr-splitButton-panel--primary': !disabled && primary,
            'agpr-splitButton-panel--top': panelPositionY === 'top'}"
        [@panelState]="panelVisible ? 'visible' : 'hidden'"
        [style.display]="panelVisible ? 'block' : 'none'"
        role="menu"
        [id]="id + '_buttonList'"
    >
        <div #itemswrapper>
            <ul class="agpr-splitButton-panel-items">
                <ng-container>
                    <ng-container
                        *ngTemplateOutlet="itemslist; context: {$implicit: optionsToDisplay}">
                    </ng-container>
                </ng-container>
                <ng-template #itemslist let-options>
                    @for (option of options; track option; let i = $index) {
                        <li
                            class="agpr-splitButton-panel-item"
                            [ngClass]="{
                                'agpr-splitButton-panel-item--disabled': option.disabled,
                                'agpr-splitButton-panel-item--has-description': option.description
                            }"
                            [id]="id + '_listItem_' + i"
                            (click)="onItemClick($event, option)"
                            (keyup.enter)="onItemClick($event, option)"
                            tabindex="0"
                            role="menuitem"
                            (focusout)="onFocusOut($event, item)"
                        >
                            @if (!itemTemplate) {
                                <span class="agpr-splitButton-panel-item-label">
                                    {{ option.label | localize }}
                                </span>
                            }
                            @if (option.description && !itemTemplate) {
                                <span class="agpr-splitButton-panel-item-description">
                                    {{ option.description | localize }}
                                </span>
                            }
                            <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: option}"></ng-container>
                        </li>
                    }
                </ng-template>
            </ul>
        </div>
    </div>
</div>
